
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/articles/add-appollow-to-your-home-screen",
      function () {
        return require("private-next-pages/articles/add-appollow-to-your-home-screen.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/articles/add-appollow-to-your-home-screen"])
      });
    }
  